/**
 * Semantic version of the SDK bundle. Injected at build time from package.json
 * via Vite's `define` config — package.json is the single source of truth.
 */
export const SDK_VERSION: string = __SDK_VERSION__;

export { QuantumContracts } from "./QuantumContracts";
export { KNOWN_ERROR_CODES } from "./types";
export type {
  ContractConfig,
  ContractErrorCode,
  ContractErrorPayload,
  ContractEventHandler,
  ContractEventName,
  ContractEventPayload,
  ContractEventsMap,
  KnownContractErrorCode,
} from "./types";
